import React, { Component } from "react";

import { TFunction, i18n } from 'i18next';
import { ITheme, IStyle } from 'office-ui-fabric-react/lib/Styling';
import { IStyleFunctionOrObject, customizable } from '@uifabric/utilities/lib/';
import { ActionButton } from 'office-ui-fabric-react/lib/Button';

import { globalContext } from '../helpers/GlobalContexts';

interface State {

}

/**
 * This interface defines the props of the dialog component.
 */
interface Props {
    t: TFunction,
    tReady: boolean,
    i18n: i18n,
    theme?: ITheme,
    styles?: IStyleFunctionOrObject<StyleProps, Styles>;
}

interface StyleProps {
    theme?: ITheme;
}

interface Styles {
    content: IStyle;
}

/**
 * This component is the top-level component of the generic dialog popup.
 */
@customizable('LogDialog', ['theme', 'styles'], true)
export default class LogDialog extends Component<Props, State> {
    static contextType = globalContext;
    declare context: React.ContextType<typeof globalContext>;

    state: State = {
        dummy: null
    };

    constructor(props: Props) {
        super(props);
    }

    /**
     * This function runs once during the initialisation of the component.
     */
    public async componentDidMount() {

    }

    private onEraseLogs = () => {
        this.context.globalService.logger.eraseLogs();
        this.forceUpdate();
    }

    /**
    * This function is called every time the component is rendered.
    */
    public render() {
        const { theme } = this.props;

        const logMessages = this.context.globalService.logger.getAllLogMessages().map((msg, index) => {
            return (<div className="ms-Grid-row row-sm" style={{ color: theme.palette.black }} key={`log_${index}`}>
                <div className="ms-Grid-col">{msg}</div>
            </div>);
        });

        return (
            <div id="dialog" className="ms-Grid" dir="ltr" style={{ backgroundColor: theme.palette.white, padding: '20px 30px' }}>
                <div className="ms-Grid-row row-lg" style={{ color: theme.palette.black }}>
                    <div className="ms-Grid-col ms-fontSize-xxl ms-sm10" style={{ color: theme.palette.themePrimary }}>Add-in logs</div>

                    <div className="ms-Grid-col ms-sm2" style={{ textAlign: "right" }}>
                        <ActionButton iconProps={{ iconName: 'Delete' }} ariaLabel='Erase logs' onClick={this.onEraseLogs} style={{ color: theme.palette.black }}>Erase logs</ActionButton>
                    </div>
                </div>

                {logMessages}
            </div>
        );
    }
}
